import { createReducer, on } from '@ngrx/store';
import { setSelectedFolderableOperation } from './selected-folderable-operation.action';
export const SELECTED_FOLDERABLE_OPERATION_SLICE_KEY = 'selectedFolderableOperation';
/**
 * Reducer to save the folderable item and operation to perform on it.
 * This reducer supports selecting all folderable types.
 */
export const selectedFolderableOperation = createReducer(null, on(setSelectedFolderableOperation, (_, action) => {
    return action.selectedOperation;
}));
